module.exports = __webpack_public_path__ + "static/media/boton-acompana.9ef8db7e.svg";